import { render, staticRenderFns } from "./ReportServicesDetails.vue?vue&type=template&id=fc64308e&scoped=true&"
import script from "./ReportServicesDetails.vue?vue&type=script&lang=js&"
export * from "./ReportServicesDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReportServicesDetails.vue?vue&type=style&index=0&id=fc64308e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc64308e",
  null
  
)

export default component.exports